import { Component, OnInit, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Compra } from '../../../models/compra';
import { Venta } from '../../../models/venta';
import { CompraListModalComponent } from '../../../components/modals/compra-list-modal/compra-list-modal.component';
import { VentaListModalComponent } from '../../../components/modals/venta-list-modal/venta-list-modal.component';
import { TransferenciasListModalComponent } from '../../../components/modals/transferencias-list-modal/transferencias-list-modal.component';
import * as numeral from 'numeral';
import { CompraDetalle } from '../../../models/compra_detalle';
import { ImpuestoService } from '../../../services/impuesto.service';
import { Impuesto } from '../../../models/impuesto';
import { Guiaremision } from '../../../models/guiaremision';
import { GuiaremisionDetalle } from '../../../models/guiaremision_detalle';
import { ParametroService } from '../../../services/parametro.service';
import { SessionService } from '../../../services/session.service';
import { Validation } from '../../../config/validation';
import { ComprobanteService } from '../../../services/comprobante.service';
import { SweetMessage } from '../../../config/sweet-message';
import { Caja } from '../../../models/caja';
import{ CajaService } from '../../../services/caja.service';
import { GuiaremisionService } from '../../../services/guiaremision.service';
import { VentaService } from '../../../services/venta.service';
import * as moment from 'moment';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { VentaDetalle } from '../../../models/venta_detalle';
import { CbtContadorService } from '../../../services/cbt-contador.service';
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';
import { Cliente } from '../../../models/cliente';
import { ProductoModalComponent } from '../../modals/producto-modal/producto-modal.component';
import { DatosAdicionales } from '../../../models/datos-adicionales';
import { TransportistaModalComponent } from '../../modals/transportista-modal/transportista-modal.component';
import { Transportista } from '../../../models/transportista';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { ValidarCorreoService } from '../../../services/validar-correo.service';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';




@Component({
  selector: 'app-guiaremision-add',
  templateUrl: './guiaremision-add.component.html',
  styleUrls: ['./guiaremision-add.component.css'],
  providers: [
		ImpuestoService,
		ParametroService,
		ComprobanteService,
		CajaService,
		GuiaremisionService,
		VentaService,
		ValidarCorreoService,
	]
})
export class GuiaremisionAddComponent implements OnInit {
  public bsModalRef: BsModalRef;
	public compra: Compra;
	public venta: Venta;
	public documento:any;
	public guiaremision: Guiaremision;
	public transportista: Transportista;
	public transportista_seleccionado:Boolean;
	public venta_detalle: Array<VentaDetalle>;
	public guiaremision_detalle: Array<GuiaremisionDetalle>;
	public impuestos: Array<any>;
	public parametrosImp: Array<any>;
	public validDateFecha: Boolean;
	public vl: Validation;
	public msgSweet: SweetMessage;
	public total: number;
	public loading = false;
	public cajas: Array<Caja>;
	public caja: Caja;
	public Mod_FactElec: string;
	public fecha_emision;
	public is_numero_manual: boolean;
	public numero_documento: String;
	public Tipo_Guia: String;
	public fecha_actual;
	public fecha_MesAnt;
	public correos: Array<any>;
	public numero_decimales: number;
	public format_decimal: String;
	public cliente: Cliente;
	public detalle: String;
	public guiDetalle: GuiaremisionDetalle;
	public datos: Array<DatosAdicionales>
	public correo_invalid:Boolean;
	@Input() modal: boolean;
	@Input() venta_id: String;
	@Output() cerrarModal = new EventEmitter();

  constructor(
		private modalService: BsModalService,
		public fb: FormBuilder,
		public impuestoService: ImpuestoService,
		public parametroService: ParametroService,
		private ss: SessionService,
		public comprobanteService: ComprobanteService,
		public cajaService: CajaService,
		public guiaremisionService: GuiaremisionService,
		public cbtContadorService: CbtContadorService,
		public ventaService : VentaService,
		public correoService:ValidarCorreoService,
  ) {
		this.compra = new Compra();
		this.venta = new Venta();
		this.documento = {};
		this.documento['destino'] = {};
		this.guiaremision = new  Guiaremision();
		this.transportista = new Transportista();
		this.transportista_seleccionado = false;
		this.venta_detalle = [];
		this.guiaremision_detalle = [];
		this.impuestos = [];
		this.parametrosImp = [];
		this.vl = new Validation();
		this.msgSweet = new SweetMessage();
		this.total = 0;
		this.cajas = [];
		this.caja = new Caja();
		this.Mod_FactElec = "";
		this.fecha_emision = moment(this.fecha_emision);
		this.guiaremision.fecha_inicial_transporte = moment(this.fecha_emision);
		this.guiaremision.fecha_final_transporte = moment(this.fecha_emision);
		this.guiaremision.tipo_identificacion_id = 1;
		this.transportista.tipo_identificacion_id = 1;
		this.fecha_actual = moment(this.fecha_actual);
        this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
		this.is_numero_manual = false;
		this.numero_documento = "";
		this.Tipo_Guia = "";
		this.correos = [];
		this.numero_decimales = 2;
		this.format_decimal = "0,0.00";
		this.cliente = new Cliente();
		this.detalle = "";
		this.guiDetalle = new GuiaremisionDetalle();
		this.datos = [];
		this.modal = false;
		this.venta_id = "";
  }

	ngOnInit() {
		this.loading = true;

		let p1 = this.getCajas();
		let p2 = this.getParametros();
		let p3 = this.getParamDocumentoManual();
		let p4 = this.getParamNumeroDecimales();

		Promise.all([p1,p2,p3,p4]).then(
			res => this.loading = false,
			err => this.loading = false,
		);

		if( this.venta_id != "" ){
			this.venta.id = this.venta_id;
			this.getDataVenta(this.venta);
		}

		this.Mod_FactElec = this.ss.getData("mod_felectronica");
	}

	getParametros(){
		return new Promise((resolve, reject) => {
			this.parametroService.getAll("?in[id]=3,4,5,6").subscribe(
				res => {
					this.parametrosImp = res.data;
					resolve();
				},
				err => {
					this.parametrosImp = [];
					reject();
				}
			);
		});
	}

	getCajas(){
		return new Promise((resolve, reject) => {
			this.cajaService.getAll("?embed=sucursal&sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
				res => {
					this.cajas = res.data;
					if( this.cajas.length == 1 ){
						
						this.caja.id = this.cajas[0].id;
					
						this.onChangeCaja();
					}

					resolve();
				},
				err => {
					this.cajas = [];
					reject(err);
				}
			);
		});
	}
	
	onChangeCaja(){

		this.getNumeroComprobante();
  	}

	getNumeroComprobante(){

		if( !this.caja.id ){
            this.msgSweet.showMessage('error-message', "Seleccione la caja");
            return;
		}
		
		let caja = this.cajas.filter(x => x.id = this.caja.id)[0];

		this.loading = true;

		if(this.Mod_FactElec){
			this.guiaremision.tipo_comprobante_id = 7; //guia remision eelctronica
		}else{
			this.guiaremision.tipo_comprobante_id = 6; //guia remision normal
		}
        this.comprobanteService.getSecuencial(this.guiaremision.tipo_comprobante_id, caja.id).subscribe(
            res => {
				this.loading = false;
                if(res.secuencial){
                    this.guiaremision.serie = caja.sucursal.establecimiento;
                    this.guiaremision.punto_emision = caja.punto_emision;
                    this.guiaremision.secuencial = res.secuencial;

                    this.guiaremision.numero_documento = this.guiaremision.serie + "-" + this.guiaremision.punto_emision + "-" + this.guiaremision.secuencial;
                }else{
                    this.guiaremision.serie = "";
                    this.guiaremision.punto_emision = "";
                    this.guiaremision.secuencial = "";
                    this.guiaremision.numero_documento = "";
                }
            },
            err => {
				this.loading = false;
                this.compra.serie = "";
                this.compra.punto_emision = "";
                this.compra.secuencial = "";
                this.compra.numero_documento = "";
                
                this.msgSweet.showMessage('error-message', err);
            }
		);
	}
	  
  	getParamDocumentoManual(){
		return new Promise((resolve, reject) => {
			let documento_manual_id = 9;
			this.parametroService.getById(documento_manual_id).subscribe(
				res => {
					this.is_numero_manual = (res.valor.toString().trim() === "SI");
					resolve();
				},
				err => {
					this.is_numero_manual = false;
					reject(err);
				}
			);
		});
	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
    }

	onIniDate() {
		let today = new Date();
		let dd = today.getDate();
		let mm = today.getMonth() + 1; //January is 0!
		let dia = "";
		let mes = "";

		var yyyy = today.getFullYear();
		dia = "" + dd;
		mes = "" + mm;
		if (dd < 10) {
			dia = "0" + dd;
		}
		if (mm < 10) {
			mes = "0" + mm;
		}
		let today2 = dia + '/' + mes + '/' + yyyy;
		this.guiaremision.fecha_emision = today2;
		this.guiaremision.fecha_final_transporte = today2;
		this.guiaremision.fecha_inicial_transporte = today2;
	}

	onValidDateFecha(fecha){
        return this.validDateFecha = this.vl.validDate(fecha.toString());
	}

	getDataVenta(venta){
		this.ventaService.getById(venta.id, "?embed=tipocomprobante,bodega,cliente?embed=tipoidentificacion,guiaremision,retencion,detalle?embed=producto&sort=-fecha_emision,-secuencial&status=A").subscribe(res=>{
			this.venta = res.data;
			this.setDataDocumento(this.venta);
		},err=>{

		});
	}

	setDataDocumento(venta){
		this.guiaremision_detalle = [];
		this.documento['id'] = venta.id;
		this.documento['fecha_emision'] = venta.fecha_emision;
		this.documento['serie'] = venta.serie;
		this.documento['punto_emision'] = venta.punto_emision;
		this.documento['secuencial'] = venta.secuencial;
		this.documento['numero_autorizacion'] = venta.numero_autorizacion;
		this.correos = [];
		this.documento['destino'] = {};
		this.guiaremision.cliente_id = venta.cliente.id;
		this.documento['destino']['dni'] = venta.cliente.dni;
		this.documento['destino']['razon_social'] = venta.cliente.razon_social;
		this.documento['destino']['direccion'] = venta.cliente.direccion;
		this.documento['destino']['celular'] = venta.cliente.celular;
		this.documento['destino']['telefono'] = venta.cliente.telefono;
		this.correos = venta.cliente.correo.split(',');
		this.documento['destino']['correo'] = this.correos;

		this.documento['detalle'] = venta.detalle;
		
		this.documento.detalle.forEach(venta_detalle => {
			let guiaremision_detalle = new GuiaremisionDetalle();
			guiaremision_detalle.cantidad = venta_detalle.cantidad;
			guiaremision_detalle.producto_id = venta_detalle.producto.id;
			guiaremision_detalle.detalle = venta_detalle.detalle;
			guiaremision_detalle.empresa_id = this.ss.getData('empresa_id');
			guiaremision_detalle.sucursal_id = this.ss.getData('sucursal_id');
			guiaremision_detalle.usuario_id = this.ss.getData('usuario_id');
			guiaremision_detalle.producto.codigo = venta_detalle.producto.codigo;
			guiaremision_detalle.producto.nombre = venta_detalle.producto.nombre;
			guiaremision_detalle.producto.descripcion = venta_detalle.producto.descripcion;
			this.guiaremision_detalle.push(guiaremision_detalle);
		});
	}

	onSearch(){
		let qs = "";
		const initialState = { qs, numero_decimales: this.numero_decimales };

		if(this.guiaremision.motivo_traslado == "venta"){
			this.Tipo_Guia = "V";
			this.bsModalRef = this.modalService.show(VentaListModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
			this.bsModalRef.content.onSelectedRow.take(1).subscribe(venta => {
				/*if(venta.guiaremision){
					this.msgSweet.showMessage('error-message','La factura seleccionada ya tiene una guia de remisión');
					this.documento = {};
					this.correos = [];
					this.documento['destino'] = {};
					this.guiaremision_detalle = [];
				}else{*/
					
				//}
				this.setDataDocumento(venta);
			});
		}
		else if(this.guiaremision.motivo_traslado == "tranf"){
			this.Tipo_Guia = "T";
			this.bsModalRef = this.modalService.show(TransferenciasListModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
			this.bsModalRef.content.onSelectedRow.take(1).subscribe(tranf => {
				if(tranf.guiaremision){
					this.msgSweet.showMessage('error-message','La transferencia seleccionada ya tiene una guía de remisión');
					this.documento = {};
					this.correos = [];
					this.documento['destino'] = {};
					this.guiaremision_detalle = [];
				}
				else{
					this.guiaremision_detalle = [];
					this.correos = [];
					this.documento['id'] = tranf.id;
					this.documento['destino'] = {};
					this.guiaremision.cliente_id = tranf.bodega_e.id;
					this.documento['destino']['dni'] = this.ss.getData('emp_ruc');
					this.documento['destino']['razon_social'] = tranf.bodega_e.sucursal.nombre;
					this.documento['destino']['direccion'] = tranf.bodega_e.sucursal.direccion;
					this.documento['destino']['celular'] = tranf.bodega_e.sucursal.celular;
					this.documento['destino']['telefono'] = tranf.bodega_e.sucursal.telefono;
					this.correos = tranf.bodega_e.sucursal.correo.split(',');
					this.documento['destino']['correo'] = this.correos;

					this.documento['detalle'] = tranf.detalle;
						
					this.documento.detalle.forEach(tranf_detalle => {
						let guiaremision_detalle = new GuiaremisionDetalle();
						guiaremision_detalle.cantidad = tranf_detalle.cantidad;
						guiaremision_detalle.producto_id = tranf_detalle.producto.id;
						guiaremision_detalle.empresa_id = this.ss.getData('empresa_id');
						guiaremision_detalle.sucursal_id = this.ss.getData('sucursal_id');
						guiaremision_detalle.usuario_id = this.ss.getData('usuario_id');
						guiaremision_detalle.producto.codigo = tranf_detalle.producto.codigo;
						guiaremision_detalle.producto.nombre = tranf_detalle.producto.nombre;
						this.guiaremision_detalle.push(guiaremision_detalle);
					});
				}
			});
		}
		else if(this.guiaremision.motivo_traslado == "compra"){
			this.Tipo_Guia = "C";
			this.bsModalRef = this.modalService.show(CompraListModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
			this.bsModalRef.content.onSelectedRow.take(1).subscribe(compra => {
				if(compra.guiaremision){
					this.msgSweet.showMessage('error-message','La factura seleccionada ya tiene una guía de remisión');
					this.documento = {};
					this.correos = [];
					this.documento['destino'] = {};
					this.guiaremision_detalle = [];
				}
				else{
					this.guiaremision_detalle = [];
					this.correos = [];
					this.documento['id'] = compra.id;
					this.documento['fecha_emision'] = compra.fecha_emision;
					this.documento['serie'] = compra.serie;
					this.documento['punto_emision'] = compra.punto_emision;
					this.documento['secuencial'] = compra.secuencial;
					this.documento['numero_autorizacion'] = compra.numero_autorizacion;

					this.documento['destino'] = {};
					this.documento['destino']['dni'] = compra.proveedor.dni;
					this.documento['destino']['razon_social'] = compra.proveedor.razon_social;
					this.documento['destino']['direccion'] = compra.proveedor.direccion;
					this.documento['destino']['celular'] = compra.proveedor.celular;
					this.documento['destino']['telefono'] = compra.proveedor.telefono;
					this.correos = compra.proveedor.correo.split(',');
					this.documento['destino']['correo'] = this.correos;

					this.documento['detalle'] = compra.detalle;
					
					this.documento.detalle.forEach(compra_detalle => {
						let guiaremision_detalle = new GuiaremisionDetalle();
						guiaremision_detalle.cantidad = compra_detalle.cantidad;
						guiaremision_detalle.producto_id = compra_detalle.producto.id;
						guiaremision_detalle.empresa_id = this.ss.getData('empresa_id');
						guiaremision_detalle.sucursal_id = this.ss.getData('sucursal_id');
						guiaremision_detalle.usuario_id = this.ss.getData('usuario_id');
						guiaremision_detalle.producto.codigo = compra_detalle.producto.codigo;
						guiaremision_detalle.producto.descripcion = compra_detalle.producto.descripcion;
						this.guiaremision_detalle.push(guiaremision_detalle);
					});
				}
			});
		}
	}

	onSearchTransportista(){
		const initialState = {};
		this.transportista_seleccionado = false;
		this.bsModalRef = this.modalService.show(TransportistaModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendTransportista.take(1).subscribe((value) => {
			this.sendObjectTransportista(value);
			this.transportista_seleccionado = true;
		});
	}

	sendObjectTransportista(event) {
		//obtencion del producto que envia el componente producto-modal
		this.transportista = event;
	}

	openDialogCliente() {
        this.correos = [];
		const initialState = {qs: "&embed=tipoidentificacion"};
		this.bsModalRef = this.modalService.show(ClienteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

        this.bsModalRef.content.sendCliente.take(1).subscribe((cliente) => {
			this.cliente = cliente;
			

			this.documento['destino'] = {};
			this.guiaremision.cliente_id = this.cliente.id;
			this.documento['destino']['dni'] = this.cliente.dni;
			this.documento['destino']['razon_social'] = this.cliente.razon_social;
			this.documento['destino']['direccion'] = this.cliente.direccion;
			this.documento['destino']['celular'] = this.cliente.celular;
			this.documento['destino']['telefono'] = this.cliente.telefono;
			this.correos = this.cliente.correo.split(',');
			this.documento['destino']['correo'] = this.correos;

            if( this.cliente.correo.trim().length ){
                this.correos = this.cliente.correo.split(',');
            }
        });
	}
	
	onSearchProducto() {
		const initialState = {bodega_id: this.compra.bodega_id,if_uso_lote:false};
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
			this.sendObjectProducto(value)
		});
	}

	sendObjectProducto(event) {
		let producto = event;

		let guiaremision_detalle = new GuiaremisionDetalle();
		guiaremision_detalle.cantidad = 1;
		guiaremision_detalle.producto_id = producto.id;
		guiaremision_detalle.empresa_id = this.ss.getData('empresa_id');
		guiaremision_detalle.sucursal_id = this.ss.getData('sucursal_id');
		guiaremision_detalle.usuario_id = this.ss.getData('usuario_id');
		guiaremision_detalle.producto.codigo = producto.codigo;
		guiaremision_detalle.producto.nombre = producto.nombre;
		guiaremision_detalle.producto.descripcion = producto.descripcion;

		this.guiaremision_detalle.push(guiaremision_detalle);
	}

	onSubmit(){
		let preg = "¿Está seguro de querer guardar el documento?";
		const initialState = { Pregunta: preg, Respuesta: false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, { initialState }));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if (Respuesta == true) {
				this.setValueEntity();

				this.loading = true;

				if(this.Mod_FactElec){
					let json = this.setGuiaRemisionElectronica();
					this.guiaremision.json_string = json;
				}
				this.guiaremisionService.save(this.guiaremision).subscribe(
					res => {
						this.loading = false;
						this.msgSweet.showMessage('success-message', res.message);
						this.venta = new Venta();
						this.guiaremision = new  Guiaremision();
						this.transportista=new Transportista();
						this.documento = {};
						this.documento['destino'] = {};
						this.guiaremision_detalle = [];
						this.total = 0;
						this.numero_documento = "";
						this.correos = [];
						this.datos = [];
						this.onIniDate();
						this.caja = new Caja();
						this.cerrarModal.emit({close:true, isSaved:true});
						if( this.Mod_FactElec ){
							this.cbtContadorService.actualizarContador();
						}
					},
					err => {
						this.loading = false;
						this.msgSweet.showMessage('error-message',err);
					}
				);

			}
		
		
		});
	}

	onCerrarModal(){
		this.cerrarModal.emit({close:true, isSaved: false});
	}

	setMotivo(tipo){
		switch(tipo){
			case "venta":
				return "Venta";
			case "tranf":
				return "Transferencia";
		}
		
	}

	setGuiaRemisionElectronica(){
		let guiaremisionElectronica = {};
        guiaremisionElectronica['datos'] = {};
        guiaremisionElectronica['datos']['infoTributaria'] = {};
        guiaremisionElectronica['datos']['infoTributaria']['ambiente'] = "";
        guiaremisionElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
        guiaremisionElectronica['datos']['infoTributaria']['razonSocial'] = "";
        guiaremisionElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
        guiaremisionElectronica['datos']['infoTributaria']['claveAcceso'] = "";
        guiaremisionElectronica['datos']['infoTributaria']['codDoc'] = "06"; //guiaremision
        guiaremisionElectronica['datos']['infoTributaria']['estab'] = this.guiaremision.serie;
        guiaremisionElectronica['datos']['infoTributaria']['ptoEmi'] = this.guiaremision.punto_emision;
        guiaremisionElectronica['datos']['infoTributaria']['secuencial'] = this.guiaremision.secuencial.toString().padStart(9,"0");
        guiaremisionElectronica['datos']['infoTributaria']['dirMatriz'] = "";

        guiaremisionElectronica['datos']['infoGuiaRemision'] = {};
		guiaremisionElectronica['datos']['infoGuiaRemision']['dirEstablecimiento'] =  "";
		guiaremisionElectronica['datos']['infoGuiaRemision']['dirPartida'] =  "";
		guiaremisionElectronica['datos']['infoGuiaRemision']['razonSocialTransportista'] =  this.guiaremision.razonSocial_transportista;
		guiaremisionElectronica['datos']['infoGuiaRemision']['tipoIdentificacionTransportista'] = (this.guiaremision.tipo_identificacion_id == 1 ? "04":"05");
		guiaremisionElectronica['datos']['infoGuiaRemision']['rucTransportista'] = this.guiaremision.dni_transportista;
		guiaremisionElectronica['datos']['infoGuiaRemision']['obligadoContabilidad'] =  (this.ss.getData('es_obligado') ? "SI":"NO");
		guiaremisionElectronica['datos']['infoGuiaRemision']['fechaIniTransporte'] = moment(this.guiaremision.fecha_inicial_transporte).format("DD/MM/YYYY");
		guiaremisionElectronica['datos']['infoGuiaRemision']['fechaFinTransporte'] = moment(this.guiaremision.fecha_final_transporte).format("DD/MM/YYYY");
        guiaremisionElectronica['datos']['infoGuiaRemision']['placa'] = this.guiaremision.placa_transporte;

		guiaremisionElectronica['datos']['destinatarios'] = [];
        let destinatario = {};
		destinatario['identificacionDestinatario'] = this.documento.destino.dni;
		destinatario['razonSocialDestinatario'] = this.documento.destino.razon_social;
		let dirDestinatario = (this.documento.destino.direccion).replace(/\//g,'-');
		dirDestinatario = dirDestinatario.replace(/\n/g,", ");
		destinatario['dirDestinatario'] = dirDestinatario;
		destinatario['motivoTraslado'] = this.setMotivo(this.guiaremision.motivo_traslado);

		if(this.Tipo_Guia == "V" && this.guiaremision.modalidad != "SD"){
			destinatario['codDocSustento'] = "01";
			destinatario['numDocSustento'] = this.documento.serie+"-"+this.documento.punto_emision+"-"+this.documento.secuencial.toString().padStart(9,"0");
			destinatario['numAutDocSustento'] = this.documento.numero_autorizacion;
			destinatario['fechaEmisionDocSustento'] = moment(this.documento.fecha_emision).format("DD/MM/YYYY");
		}

		destinatario['detalles'] = [];
		this.guiaremision_detalle.forEach(detalles => {
			let detalle = {};
			detalle['codigoInterno'] = (detalles.producto.codigo).replace(/\//g,'-');

			let detalle_item = detalles.detalle.toString().replace(/\n/g,", ");
			(detalles.producto.nombre + (detalles.detalle.length>0?" - " + detalle_item:"")).replace(/\//g,'-');

			detalle['descripcion'] = (detalles.producto.nombre + (detalles.detalle.length>0?" - " + detalle_item:"")).replace(/\//g,'-');; //(detalles.producto.nombre).replace(/\//g,'-');
			detalle['cantidad'] = detalles.cantidad;
			destinatario['detalles'].push(detalle);
		});
        guiaremisionElectronica['datos']['destinatarios'].push(destinatario);
		
        guiaremisionElectronica['datos']['infoAdicional'] = [];
        let adicional = {};
        adicional['Email'] = this.correos.toString();// this.documento.destino.correo;
		adicional['Direccion'] = (this.documento.destino.direccion).replace(/\//g,'-');
		
		let telefono = "0999999999";
        if( this.documento.destino.telefono.toString().trim().length > 0 ){
            telefono = this.documento.destino.telefono.toString();
        }
        if( this.documento.destino.celular.toString().trim().length > 0 ){
            telefono = this.documento.destino.celular.toString();
        }
		adicional['Telefono'] = telefono;

		if( this.guiaremision.observacion.trim().length > 0 ){
			adicional['Observacion'] = this.guiaremision.observacion.trim().toString().replace(/\n/g,", ");
		}

		guiaremisionElectronica['datos']['infoAdicional'].push(adicional);
		
		this.datos.forEach(dato => {
            adicional[dato.descripcion.toString()] = dato.valor.toString();
        });

        return guiaremisionElectronica;
  	}

	setValueEntity(){
		this.guiaremision.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.guiaremision.numero_documento = this.guiaremision.serie + "-" + this.guiaremision.punto_emision + "-" + this.guiaremision.secuencial;
		this.guiaremision.is_secuencial_manual = this.is_numero_manual;
        if( this.is_numero_manual ) this.guiaremision.numero_documento = this.numero_documento;
		this.guiaremision.empresa_id = this.ss.getData('empresa_id');
		this.guiaremision.sucursal_id = this.ss.getData('sucursal_id');
		this.guiaremision.usuario_id = this.ss.getData('usuario_id');
		this.guiaremision.caja_id = this.caja.id;
		this.guiaremision.documento_id = this.documento.id;
		this.guiaremision.detalle = this.guiaremision_detalle;
		this.guiaremision.destino = this.documento.destino.direccion;
		this.guiaremision.tipo_identificacion_id = this.transportista.tipo_identificacion_id;
		this.guiaremision.dni_transportista = this.transportista.dni;
		this.guiaremision.razonSocial_transportista = this.transportista.nombre;
		this.guiaremision.placa_transporte = this.transportista.placa;
		this.guiaremision.transportista_id = this.transportista.id;
	}

	isValidForm(){
		if( this.is_numero_manual ){
            if( this.numero_documento.trim().length === 0 ){
                return false;
            }else{
                if( parseFloat(this.numero_documento.trim()) < 1 ){
                    return false;
                }
            }
        }
		if( !this.guiaremision.numero_documento ){
			return false;
		}
		if( !this.guiaremision_detalle.length ){
			return false;
		}
		if( this.guiaremision_detalle.length === 0 ){
			return false;
		}
		/*if(this.guiaremision.tipo_identificacion_id == 1){
            if(this.guiaremision.dni_transportista.length != 13){
            	return false;
			}
		}
		else{
			if(this.guiaremision.dni_transportista.length != 10){
            	return false;
			}
		}*/

		// if(this.guiaremision.dni_transportista){
		// 	if(this.guiaremision.tipo_identificacion_id == 1 && this.guiaremision.dni_transportista.length < 13){
		// 		return false;
		// 	}
		// 	if(this.guiaremision.tipo_identificacion_id == 2 && this.guiaremision.dni_transportista.length < 10){
		// 		return false;
		// 	}
		// 	if(this.guiaremision.tipo_identificacion_id == 3 && this.guiaremision.dni_transportista.length < 15){
		// 		return false;
		// 	}
		// }else{
		// 	return false;
		// }
		// if( this.guiaremision.razonSocial_transportista.toString().trim().length < 1 ){
		// 	return false;
		// }
		// if( this.guiaremision.placa_transporte.toString().trim().length < 1 ){
		// 	return false;
		// }

		if(this.guiaremision.venta.guiaremision){
			return false;
		}
		if(this.fecha_emision < this.fecha_MesAnt){
            return false;
		}
		if( !this.correos.length ){
			return false;
		}
		if (!this.documento.destino.direccion) {
			return false;
		}

		if (!this.transportista_seleccionado) {
			if (!Boolean(this.guiaremision.modalidad == "CD") || !Boolean(this.guiaremision.modalidad == "SD") ) {
				return false;
			}
		}
		if (this.correo_invalid) {
			return false;
		}

		return true;
	}

	onChangeFecha(event){
        if(event < this.fecha_MesAnt){
            this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");            
        }
	}
	
	onChangeIdentificacion(id){
		this.guiaremision.tipo_identificacion_id = id;
	}

	onDelete(i) {
		this.guiaremision_detalle.splice(i, 1);
	}

	/*recalcularItem(event, detalle: GuiaremisionDetalle){
		//detalle.subtotal = (detalle.cantidad * detalle.precio_unitario) - detalle.desc_valor;
		//detalle.iva = parseFloat(detalle.subtotal.toString()) * parseFloat(this.IVA.toString());
		//this.recalcularFactura();
	}*/

	openModalDetalle(template: TemplateRef<any>, guiaDetalle: GuiaremisionDetalle) {
        this.detalle = guiaDetalle.detalle;
        this.guiDetalle = guiaDetalle;
        this.bsModalRef = this.modalService.show(template);
	}
	
	saveDetalle(){
        this.guiDetalle.detalle = this.detalle.toString().trim();
        this.detalle  = "";
        this.bsModalRef.hide();
    }

	onChangeModalidad(){
		this.cliente = new Cliente();
		this.guiaremision_detalle = [];
		this.correos = [];
		this.documento = {};
		this.documento['destino'] = {};
	}
	
	validarCorreo() {
		if (this.correos.length > 0) {
			let count_true = 0;
			let count_false = 0;
			for (let index = 0; index < this.correos.length; index++) {
				let res = this.correoService.isEmailValido(this.correos[index]);
				if (res) {
					count_true++;

				} else {
					count_false++;
				}

			}
			if (count_false > 0) {
				this.correo_invalid = true;
			} else {
				this.correo_invalid = false;
			}


		} else {
			this.correo_invalid = false;
		}
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/guiaremision-add/guiaremision-add.component.ts